var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _vm.search.length > 0
            ? _c("oaFromBox", {
                attrs: {
                  btnText: "导出",
                  isAddBtn: true,
                  btnIcon: false,
                  isViewSearch: false,
                  search: _vm.search,
                  title: "汇报管理",
                  total: _vm.totalPage,
                },
                on: {
                  addDataFn: _vm.getExportData,
                  confirmData: _vm.confirmData,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt10 table-box" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData, height: _vm.tableHeight } },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("toptable.name"),
                      prop: "name",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("toptable.department"),
                      prop: "frame_name",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("toptable.worktoday"),
                      "min-width": "250",
                      prop: "finish",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.finish,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "textover3" },
                                [_vm._v(_vm._s(item))]
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("toptable.tomorrowplan"),
                      "min-width": "250",
                      prop: "plan",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.types !== 3
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.plan,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "textover3",
                                        },
                                        [_vm._v(_vm._s(item))]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c("div", [_vm._v("--")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("user.work.dailytype"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.types === 1
                              ? _c("span", [_vm._v("周报")])
                              : row.types === 2
                              ? _c("span", [_vm._v("月报")])
                              : row.types === 3
                              ? _c("span", [_vm._v("汇报")])
                              : _c("span", [_vm._v("日报")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("toptable.updatetime"),
                      prop: "updated_at",
                      width: "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("user.work.creationtime"),
                      prop: "created_at",
                      width: "160",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("public.operation"),
                      fixed: "right",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["hr:report:check"],
                                    expression: "['hr:report:check']",
                                  },
                                ],
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEdit(
                                      scope.row.daily_id,
                                      true,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("public.check")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.tableFrom.page,
                      "page-size": _vm.tableFrom.limit,
                      "page-sizes": [15, 20, 30],
                      total: _vm.totalPage,
                      layout: "total, sizes,prev, pager, next, jumper",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("addBox", {
        ref: "addBox",
        attrs: {
          "daily-id": _vm.dailyIndex,
          "edit-data": _vm.editData,
          "edit-id": _vm.editId,
        },
        on: { tableList: _vm.tableList },
      }),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          "export-data": _vm.exportData,
          "save-name": _vm.saveName,
          template: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }